import { useStore } from "vuex";
import requestApi from '@/api/requestApi'
import { setErrorsFields } from '@/helpers/errorsFields'
import { serverUrl } from '@/helpers/accesoVariables';



export const signInUser = async ({ commit }, user) => {
    const { login, password } = user

    try {
        commit('showProcessHideAlert')
        await requestApi.get(serverUrl + '/sanctum/csrf-cookie')
        const { data } = await requestApi.post('/auth/ingresar', { login, password })
        commit('loginUser', { user: data.data })
        commit('setCurrentPage', 'dashboard')
        commit('hideProcessShowAlert', { messageServer: 'Usuario autenticado', errorsFields: {}, typeAlert: 'success' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const logout = async ({ commit }, porInactividad) => {

    try {
        commit('showProcessHideAlert')
        const { data } = await requestApi.post('/auth/salir', { porInactividad: porInactividad })
        commit('logout')
        commit('hideProcessShowAlert', { messageServer: '', errorsFields: {}, typeAlert: 'success' })
        window.Echo.leaveChannel(`session`);
        return { response: true }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const requestLinkChangePassword = async ({ commit }, { email }) => {

    try {
        commit('showProcessHideAlert')
        await requestApi.get(serverUrl + '/sanctum/csrf-cookie')
        const { data } = await requestApi.post('/auth/enlaceCambiarContrasena', { email })
        commit('hideProcessShowAlert', { messageServer: data.data, errorsFields: {}, typeAlert: 'success' })
        return { response: true }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const changePassword = async ({ commit }, { formData }) => {

    try {
        commit('showProcessHideAlert')
        await requestApi.get(serverUrl + '/sanctum/csrf-cookie')
        const { data } = await requestApi.post('/auth/cambiarContrasena', formData)
        commit('hideProcessShowAlert', { messageServer: data.data, errorsFields: {}, typeAlert: 'success' })
        return { response: true }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}


export const checkAuthentication = async ({ commit }) => {

    const store = useStore()
    try {
        if (store.state['auth']['permissions'].length === 0 && store.state['auth']['UserLoggedIn'] != null) {
            const { data } = await requestApi.get('/auth/user')
            const { usuario, fechaSistema, listas, parametros, permisos, parentesco } = data.data
            // const user = data.data;
            // const resp = await requestApi.get('/auth/getPermissionsUser')
            commit('setUserPermissions', { user: usuario, permissions: permisos, parameters: parametros, system: fechaSistema })
            store.commit('parameterization/setListsSelect', { data: listas.listas })
            store.commit('parameterization/setListsArmed', { data: listas.fuerzasArmadas })
            store.commit('parameterization/setPrincipalList', { data: listas.tiposListas })
            store.commit('relationship/setRelationshipSelect', { data: listas.parentesco })
        }
        commit('hideProcessShowAlert', { messageServer: '', errorsFields: {}, typeAlert: 'success' })
        return { response: true }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const changeAnalystShift = async ({ commit }, { codShift }) => {
    try {
        commit('showProcessHideAlert', 'list')
        const { data } = await requestApi.post(`/users/cambiarTurnoAnalistas`, { estadoTurno: codShift })
        commit('hideProcessShowAlert', { messageServer: 'Operación exitosa', errorsFields: {}, typeAlert: 'success' })
        commit('updateShiftUser', { codShift })
        return { response: true }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const enableTwoFactor = async ({ commit }) => {
    try {
        commit('showProcessHideAlert', 'enableTwoFactor')
        const { data } = await requestApi.post(`/auth/enable-two-factor`)
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'enableTwoFactor' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}

export const verifyTwoFactor = async ({ commit }, code) => {
    try {
        commit('showProcessHideAlert', 'verifyTwoFactor')
        const { data } = await requestApi.post(`/auth/verify-two-factor`, { code: code })
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'verifyTwoFactor' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error, typeProcess: 'verifyTwoFactor' })
    }
}

export const confirmTwoFactor = async ({ commit }, formData) => {
    try {
        commit('showProcessHideAlert', 'confirmTwoFactor')
        const { data } = await requestApi.post(`/auth/confirm-two-factor`, formData)
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'confirmTwoFactor' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const regenerateRecoveryCode = async ({ commit }, token) => {
    try {

        commit('showProcessHideAlert', 'regenerateRecoveryCode')
        const { data } = await requestApi.post(`/auth/regenerate-recovery-codes`, { token })
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'regenerateRecoveryCode' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}

export const disableTwoFactor = async ({ commit }, token) => {
    try {

        commit('showProcessHideAlert', 'disableTwoFactor')
        const { data } = await requestApi.post(`/auth/disable-two-factor`, { token })
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'disableTwoFactor' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const validateOtpPassword = async ({ commit }, { type = 'otp', code, recoverCode = false }) => {
    try {
        commit('showProcessHideAlert', 'validateOtpPassword')
        const { data } = await requestApi.post(`/auth/validate-${type}`, { code, recoverCode })
        commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'validateOtpPassword' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}
export const infoBackend = async ({ commit }) => {
    try {
        // commit('showProcessHideAlert', 'setInfoBackend')
        const { data } = await requestApi.get(`/auth/health`)
        commit('setInfoBackend', data)
        // commit('hideProcessShowAlert', { messageServer: data.message, errorsFields: {}, typeAlert: 'success', typeProcess: 'validateOtpPassword' })
        return { response: true, data: data.data }
    } catch (error) {
        return setErrorsFields({ modulo: 'auth', error: error })
    }
}




export const setErrorsFielFrontend = ({ commit }, errors) => {
    commit('hideProcessShowAlert', { messageServer: 'Verifique que los campos se encuentren debidamene diligenciados', errorsFields: errors, typeAlert: 'danger' })

}

export const setCurrentPage = ({ commit }, currentPage) => {
    commit('setCurrentPage', currentPage)
}






